<template>
    <a-modal
      title="同步成本"
      centered
      :width="640"
      :mask-closable="false"
      :visible="showForm"
      :confirmLoading="loading"
      @cancel="close"
    >
        <a-form-model
          ref="form"
          :model="model"
          :rules="rules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
            <a-spin :spinning="loading">
                <a-form-model-item label="投放日期" prop="day">
                  <a-date-picker v-model="model.day" valueFormat="YYYY-MM-DD" style="width:100%" />
                </a-form-model-item>

                <a-form-model-item label="快捷操作">
                  <a-button-group>
                      <a-button @click="changeDay(1)">
                        前一天
                      </a-button>
                      <a-button @click="changeDay(2)">
                        后一天
                      </a-button>
                    </a-button-group>
              </a-form-model-item>
            </a-spin>
        </a-form-model>

        <template slot="footer">
            <a-button @click="close" :disabled="loading">取消</a-button>
            <a-button type="primary" @click="submit" :disabled="loading">确定</a-button>
        </template>
    </a-modal>
</template>

<style lang="less" scoped>
@import 'SyncCost';
</style>

<script>
import SyncCost from './SyncCost'

export default SyncCost
</script>
